import { format } from 'date-fns'
import itLocale from 'date-fns/locale/it'
import { useMemo } from 'react'
import T from 'prop-types'
import { useTranslation } from 'react-i18next'

const DateCell = ({ value }) => {
  const { t } = useTranslation()
  return useMemo(() => {
    if (value) {
      return format(new Date(value), t('common.date.formatDMY'), {
        locale: itLocale,
      })
    }

    return '-'
  }, [t, value])
}

export default DateCell

DateCell.propTypes = {
  value: T.string,
}
